export default __webpack_public_path__ + "static/media/4.e1630acb.webp";